var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('b-checkbox',{attrs:{"switch":""},model:{value:(_vm.withRanks),callback:function ($$v) {_vm.withRanks=$$v},expression:"withRanks"}},[_vm._v("Affichage de tous les classements")])],1),_c('div',{ref:"render"})])}
var staticRenderFns = []

export { render, staticRenderFns }